import { requestApi } from '../util/network'

// 活动列表
export const vitiList = (data) => requestApi(
  '/LuckBuy/activityList',
  'GET',
  data,
  'member'
)

// 官方公告列表
export const noticeList = (data) => requestApi(
  '/LuckBuy/noticeList',
  'GET',
  data,
  'member'
)
export const NoticeInfo = (data) => requestApi(
  '/LuckBuy/noticeInfo',
  'GET',
  data,
  'member'
)


// 购买记录
export const BuyRecords = (data) => requestApi(
  '/LuckBuy/myBuyRecords',
  'GET',
  data,
  'member'
)

// 我要兑换
export const Exchange = (data) => requestApi(
  '/LuckBuy/exchange',
  'POST',
  data,
  'member'
)

// 兑奖列表
export const ExchangeList = (data) => requestApi(
  '/LuckBuy/exchangeList',
  'GET',
  data,
  'member'
)

// 我购买的中奖号码列表
export const MyBuyNumberList = (data) => requestApi(
  '/LuckBuy/myBuyNumberList',
  'GET',
  data,
  'member'
)

// 指定usd价格专区的活动列表
export const UsdActivityList = (data) => requestApi(
  '/LuckBuy/usdActivityList',
  'GET',
  data,
  'member'
)

// 购买活动
export const Buy = (data) => requestApi(
  '/LuckBuy/buy',
  'POST',
  data,
  'member'
)

// 轮训最新中奖信息
export const GetLatestLotteryInfo = (data) => requestApi(
  '/LuckBuy/getLatestLotteryInfo',
  'GET',
  data,
  'member'
)

// 获得的商品列表
export const WinGoodsList = (data) => requestApi(
  '/LuckBuy/winGoodsList',
  'GET',
  data,
  'member'
)

// 中奖后选择提货
export const GetGoods = (data) => requestApi(
  '/LuckBuy/getGoods',
  'GET',
  data,
  'member'
)


// 单个活动的已售份数
export const GetActivityInfo = (data) => requestApi(
  '/LuckBuy/getActivityInfo',
  'GET',
  data,
  'member'
)

// 预售
export const AdvanceBuy = (data) => requestApi(
  '/LuckBuy/advance_buy',
  'POST',
  data,
  'member'
)

// 关闭弹窗回调
export const CloseLottery = (data) => requestApi(
  '/LuckBuy/closeLottery',
  'GET',
  data,
  'member'
)
// 获取所有分区
export const GetCycleList = (data) => requestApi(
  '/LuckBuy/getCycleList',
  'GET',
  data,
  'member'
)

// 获取地址
export const GetAddressInfo = (data) => requestApi(
  '/LuckBuy/getAddressInfo',
  'GET',
  data,
  'member'
)

// 去获取兑换码
export const GetExchangeCode = (data) => requestApi(
  '/LuckBuy/getExchangeCode',
  'GET',
  data,
  'member'
)

//我的团队
export const GetMyTeam = (data) => requestApi(
  '/LuckBuy/getMyTeam',
  'GET',
  data,
  'member'
)